import PrintInvoice from './invoice';
import PrintManifest from './manifest';
import PrintOrder from './order';
import PrintResi from './resi';
import PrintShipment from './shipment';

const routes = [
  {
    path: '/print/order/:id',
    component: PrintOrder,
    action: ['read_only', 'manage'],
    service: ['nvo.tms.delivery'],
  },
  {
    path: '/print/shipment/:id',
    component: PrintShipment,
    action: ['read_only', 'manage'],
    service: ['nvo.tms.delivery'],
  },
  {
    path: '/print/invoice/:id',
    component: PrintInvoice,
    action: ['read_only', 'manage'],
    service: ['nvo.tms.delivery'],
  },
  {
    path: '/print/manifest/:id',
    component: PrintManifest,
    action: ['read_only', 'manage'],
    service: ['nvo.tms.manifest'],
  },
  {
    path: '/print/resi/:id',
    component: PrintResi,
    action: ['read_only', 'manage'],
    service: ['nvo.tms.delivery'],
  },
];

export default routes;
